import { isEmpty } from 'lodash-es';
import { useNavigate } from 'react-router-dom';
import { IJob } from 'wisestep-api';
import { WsButton, WsTitleBanner } from 'wisestep-base';

interface IUploadSpreadSheetsHeader {
  job?: IJob;
  onClose?(): void;
}

const UploadSpreadSheetsHeader = ({ job, onClose }: IUploadSpreadSheetsHeader) => {
  const navigate = useNavigate();
  // const [open, setOpen] = useState(false);
  //  const handleDrawerOpen = () => setOpen(true);
  const navigateImportCandidates = () => navigate('/import-candidates');
  const navigateToJobsListing = () => onClose && onClose();
  return (
    <WsTitleBanner
      title={
        job?.title
          ? `Submitting Candidate(s) for ${job?.title ?? ''} ${job?.jobCode}`
          : 'Import your long list of candidates mappings'
      }
      goBack={isEmpty(job) ? navigateImportCandidates : navigateToJobsListing}
      rightChildren={
        <>
          <WsButton
            onClick={() =>
              navigate('/import-candidates/bulk-upload-excel/candidate-upload-history')
            }
          >
            Import History
          </WsButton>
          {/* <ImportHistoryDrawer openDrawer={open} onClose={() => setOpen(false)} /> */}
        </>
      }
    />
  );
};
export default UploadSpreadSheetsHeader;
